import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MembersViewStore } from 'pages/settings/pages/members/pages/membersView/store/membersViewStore'

export const MembersViewContext = createContext<MembersViewStore | null>(null)

export const useMembersViewContext = () => {
  const context = useContext(MembersViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with MembersViewContext')

  return context
}

export const MembersViewProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new MembersViewStore(entities))

  useEffect(() => {
    return store.dispose
  }, [store])

  return <MembersViewContext.Provider value={store}>{children}</MembersViewContext.Provider>
}
